import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import ImgPlaceHolder from "../../constant/imgPlaceholder";
import Testimonial from "../../Home/component/Testimonial";
import { dashboardAction, departmentAction } from "../../redux/action";
import { ROUTE } from "../../route/Route";
import BreadCrumb from "../breadcrumb/BreadCrumb";
import SeoAdd from "../Seo/SeoAdd";
import PressRealease from "./component/PressRealease";
import WaitScreen from "../LodingScreen/WaitScreen";
import { useTranslation } from "react-i18next";
import SectionLoader from "../LodingScreen/SectionLoader";
import { isAws } from "../../constant/utils";
import Slider from "react-slick";
import { newsSettings } from "../../constant/sliderConfig";

function NewsUpdates() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [nUri, setNUri] = useState<any>({});
  const [cUri, setCUri] = useState<any>({});
  const [pUri, setPUri] = useState<any>({});
  const [news, setNews] = useState<any>([]);
  const [press, setPress] = useState<any>([]);
  const newsData: any = useSelector((state: any) =>
    state.dashboard.newsAndUpdate ? state.dashboard.newsAndUpdate : {}
  );
  const pressData: any = useSelector((state: any) =>
    state.dashboard.pressRelease ? state.dashboard.pressRelease : {}
  );
  const testimonialData: any = useSelector((state: any) =>
    state.dashboard.testimonial ? state.dashboard.testimonial : {}
  );
  const [cme, setCme] = useState<any>([]);
  const cmeData: any = useSelector((state: any) => (state.dashboard.cme ? state.dashboard.cme : {}));
  useEffect(() => {
    dispatch(dashboardAction.newsAndUpdateAction({}));
    dispatch(dashboardAction.pressReleaseAction({}));
    dispatch(dashboardAction.getTestimonialAction({}));
    return () => {};
  }, []);

  useEffect(() => {
    window?.scrollTo(0, 0);
    if (newsData) {
      setNUri({
        iBASE: newsData?.ImageBaseUrl,
        vBASE: newsData?.ImageBaseUrl,
        iAWS: newsData?.AwsImageBaseUrl,
        vAWS: newsData?.AwsVideoBaseUrl,
      });
      setNews(newsData?.NewsEvents);
    }
    return () => {};
  }, [newsData]);

  useEffect(() => {
    if (pressData) {
      setPUri({
        iBASE: pressData?.ImageBaseUrl,
        vBASE: pressData?.ImageBaseUrl,
        iAWS: pressData?.AwsImageBaseUrl,
        vAWS: pressData?.AwsVideoBaseUrl,
      });
      setPress(pressData?.PressRelease);
    }
    return () => {};
  }, [pressData]);

  useEffect(() => {
    window?.scrollTo(0, 0);
    dispatch(dashboardAction.cmeListAction({}));
    return () => {};
  }, []);

  useEffect(() => {
    setCUri({
      iBASE: cmeData?.ImageBaseUrl,
      vBASE: cmeData?.ImageBaseUrl,
      iAWS: cmeData?.AwsImageBaseUrl,
      vAWS: cmeData?.AwsVideoBaseUrl,
    });
    setCme(cmeData?.CMELists);
    return () => {};
  }, [cmeData]);
  return (
    <>
      <SeoAdd slug={ROUTE.NEWSANDUPDATES} />
      <BreadCrumb page={t("news_update")} data={{ slug: "", path: "" }} />
      <section className="news_section section overview-top pt-3">
        <div className="container" id="section2">
          <div className="row">
            <div className="col-md-12">
              <div className="overview-wrap text-center">
                <img src={t("images.news_banner")} className="scale" alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="news_section pb-4">
        <div className="container">
          <div /* className="row" */>
            <div className="text-center mb-3">
              <h2 className="xs-title mb-3">{t("news_and_events")}</h2>
              <p className="fs-18" style={{ color: "#9c999d" }}>
                {t("stay_up_to_date")}
              </p>
            </div>
            {Object.keys(newsData).length > 0 && Object.keys(newsData).length > 0 ? (
              <div className="news_slider">
                <Slider {...newsSettings}>
                  {news && news.length > 0 ? (
                    news?.map((item: any, i: any) => (
                      <div className="gap_slides" key={i}>
                        <Link to={`${ROUTE.NEWSANDUPDATESDETAIL}/${item?.Slug}`}>
                          <div className="news_img">
                            <img
                              src={
                                item?.Images && item?.Images?.[0]?.image
                                  ? isAws(item?.Images[0].image)
                                    ? `${nUri?.iAWS}${item?.Images[0].image}`
                                    : `${nUri?.iBASE}${item?.Images[0].image}`
                                  : t("images.news1")
                              }
                              className="scale round_img"
                              alt=""
                            />
                          </div>
                          <div className="p-3 box-white-shadow news_box_width_85">
                            <p className="f-16">{item?.Date && moment(item?.Date).format("MMM DD, YYYY")}</p>
                            <p className="f-14">{item?.ShortDetails && item?.ShortDetails?.slice(0, 500)}</p>
                          </div>
                        </Link>
                      </div>
                    ))
                  ) : (
                    <p className="col-md-12 f-20 text-center mb-5">{t("no_data_available")}</p>
                  )}
                </Slider>
              </div>
            ) : (
              <SectionLoader />
            )}
          </div>
        </div>
      </section>
      <section className="news_section pb-4">
        <div className="container">
          <div /* className="row" */>
            <div className="text-center mb-3">
              <h2 className="xs-title mb-3">{t("ecme_new")}</h2>
              <p className="fs-18" style={{ color: "#9c999d" }}>
                {t("bring_together_healthcare")}
              </p>
            </div>
            {Object.keys(cmeData).length > 0 && Object.keys(cmeData).length > 0 ? (
              <div className="news_slider">
                <Slider {...newsSettings}>
                {cme && cme.length > 0 ? (
                  cme?.map((item: any, i: any) => (
                    <div className="gap_slides" key={i}>
                      <div className="news_img">
                        <img
                          src={
                            item?.Images && item?.Images?.[0]?.image
                              ? isAws(item?.Images[0].image)
                                ? `${cUri?.iAWS}${item?.Images[0].image}`
                                : `${cUri?.iBASE}${item?.Images[0].image}`
                              : t("images.histopathology")
                          }
                          onError={(e: any) => ImgPlaceHolder(e, t("images.histopathology"))}
                          className="scale round_img"
                          alt=""
                        />
                      </div>
                      <div className="box-white-shadow news_box_width_85">
                        <div className="infobox_wrapper">
                          <h5 className="mb-3">{item?.EventTitle}</h5>
                          <div className="f-14">{item?.ShortDetails && item?.ShortDetails?.slice(0, 300)}</div>
                          <Link
                            className="infobox_button button-read-more arrow-news"
                            to={`${ROUTE.ECME}/${item?.Slug}`}
                          >
                            <img src="/assets/img/arrow-read.svg" className="scale" />
                          </Link>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <p className="col-md-12 f-20 text-center">{t("no_cme_available")}</p>
                )}
              </Slider>
              </div>
            ) : (
              <SectionLoader />
            )}
          </div>
        </div>
      </section>
      <PressRealease press={press} uri={pUri} />
      <Testimonial testimonial={testimonialData} loadingData={testimonialData} />
    </>
  );
}

export default NewsUpdates;
